import { render, staticRenderFns } from "./PublicBookingVisualSettings.vue?vue&type=template&id=1aa08c32&"
import script from "./PublicBookingVisualSettings.vue?vue&type=script&lang=ts&"
export * from "./PublicBookingVisualSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports